/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SORTING : STYLES --------------- ++++++++++ */
export default theme => ({
  sorting: {
    '& .singleselectdropdown': {
      zIndex: 3
    },
    '& .sortingpreview': {
      width: pxToEm(160),
      flexDirection: 'column',
      background: '#E7EAF7',
      color: '#000',
      border: '2px solid #7B88BC',
      borderRadius: pxToEm(4),
      gap: 0,
      '& span': {
        display: 'flex',
        justifyContent: 'space-between',
        margin: pxToEm(4),
        padding: `${pxToEm(2)} ${pxToEm(4)}`,
        borderRadius: pxToEm(4)
      },
      '& .selected': {
        background: '#000',
        color: '#FFF'
      },
      '& .caret': {
        width: pxToEm(16),
        height: pxToEm(16),
        '& path': {
          fill: '#FFF'
        }
      }
    }
  }
});
